import ShoppingCart from '@material-ui/icons/ShoppingCart';

import List from './List';

export default {
  list: List,
  icon: ShoppingCart,
};
